import { Checkbox } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./quotaCopySlice";

export default function TableCellCheckbox(params) {
   const dispatch = useDispatch();
	const quotaCopy = useSelector((state) => state.quotaCopy);
   const { selectedTableRows, quotaDetailsTable } = quotaCopy; 
   const { rows } = quotaDetailsTable;

   function handleChange(event) {
      const checked = event.target.checked;
      let selectedRows = [...selectedTableRows];
      const id = params.row.id;

      const tableRows = rows.map(item => {
         if(item.id === id) {
            return {
               ...item,
               checked,
            };
         }
         return item;
      });
      if(checked) {
         selectedRows.push(id);
      }
      else {
         selectedRows = selectedRows.filter(item => item !== id);
      }
      dispatch(setState("selectedTableRows", selectedRows));
      dispatch(setState("quotaDetailsTable", { rows: tableRows }));
   }
     
   if(params.row.quotaStatus === "Approved") {
      return (
         <span></span>
      );
   }
   return (
      <div>
         <Checkbox
             checked={params.row.checked}
             onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
         />
      </div>
   );
}
